import React from 'react';
import { SecondaryButton } from 'library';
import PaymentChoices from 'parent-portal/payments/PaymentChoices';

export default function HorizontalOptionButton({
    title,
    highlight,
    subtitle,
    icon,
    action,
    id,
    style,
    listItems,
    cardItems,
}: {
    title: string;
    highlight?: string;
    subtitle?: string;
    icon?: React.ReactNode;
    listItems?: string[];
    cardItems?: { text: string; backgroundColor: string }[];
    action: () => void;
    id?: string;
    style?: React.CSSProperties;
}) {
    return (
        <SecondaryButton onClick={action} buttonStyle={{ ...styles.button, ...style }}>
            <PaymentChoices
                title={title}
                subtitle={subtitle}
                highlight={highlight}
                listItems={listItems}
                id={id}
                icon={icon}
                cardItems={cardItems}
            />
        </SecondaryButton>
    );
}

const styles = {
    button: {
        marginTop: 10,
        maxWidth: '45%',
        justifyContent: 'flex-start',
        alignItems: 'unset',
        borderRadius: 18,
        padding: 10,
    },
};
